<template>
  <v-card class="card" color="primary">
    <v-card-title>
      <div class="text-h5 font-weight-bold">Puesto y dependencia</div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Dependencia</div>
          </v-col>
          <v-col cols="4" v-if="personal && personal.CatRamaDependencia">
            <v-row>
              <v-col cols="12">
                <BaseInput
                  v-model="personal.CatRamaDependencia.CatDependencia.catInstancia.title"
                  label="Instancia"
                ></BaseInput>
                <BaseInput v-model="personal.CatRamaDependencia.CatDependencia.nombre" label="Nombre"></BaseInput>
                <BaseInput v-model="personal.CatRamaDependencia.ramaDependencia" label="Dirección"></BaseInput>
                <template v-if="personal.CatSubArea">
                  <BaseInput v-model="personal.CatSubArea.CatArea.nombre" label="Área"></BaseInput>
                  <BaseInput v-model="personal.CatSubArea.nombre" label="Sub-área"></BaseInput>
                </template>
                <template v-else>
                  <BaseInput value="" label="Área"></BaseInput>
                  <BaseInput value="" label="Sub-área"></BaseInput>
                </template>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="8">
            <div class="text-h6 font-weight-bold">Puesto</div>
          </v-col>
          <v-col cols="4" v-if="personal && personal.CatPuestoDependencia">
            <v-row>
              <v-col cols="12">
                <BaseInput
                  v-if="personal.CatPuestoDependencia.CatTipoPuesto"
                  v-model="personal.CatPuestoDependencia.CatTipoPuesto.title"
                  label="Tipo de Puesto"
                ></BaseInput>
                <BaseInput v-else value="" label="Tipo de Puesto"></BaseInput>
                <BaseInput v-model="personal.CatPuestoDependencia.catPuesto.puesto" label="Puesto"></BaseInput>
                <BaseInput
                  v-if="perfil == PERFILES['Recursos Humanos']"
                  v-model="personal.plaza"
                  label="Plaza"
                ></BaseInput>
                <BaseInput v-if="personal.CatTurno" v-model="personal.CatTurno.title" label="Turno"></BaseInput>
                <BaseInput v-else value="" label="Turno"></BaseInput>
                <v-textarea
                  v-model="personal.CatPuestoDependencia.funciones"
                  rounded
                  readonly
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Funciones"
                  no-resize
                  rows="4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import BaseInput from '../../../base/BaseInput.vue'
import { PERFILES } from '@/perfiles.js'

export default {
  components: {
    BaseInput,
  },
  data() {
    return {
      PERFILES,
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters({
      perfil: 'getPerfil',
    }),
  },
}
</script>

<style scoped>
/* Textarea dinámico */
::v-deep .v-textarea.v-input--is-focused .v-input__control .v-input__slot::after {
  border-color: var(--v-secondary-base) !important;
}

::v-deep .v-textarea .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

::v-deep .v-textarea.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-textarea textarea {
  caret-color: var(--v-secondary-base) !important;
}

/* Cards con efectos modernos */
.card {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.1);
  transition: all 0.3s ease;
}
</style>
